import React from 'react';
import { Stack, Text } from '@moda/om';
import { PageMeta } from '../../components/PageMeta';
import { useScrollHashReferenceToView } from '../../hooks/useScrollHashReferenceToView';

import './LegalPage.scss';

export const LegalPage = () => {
  useScrollHashReferenceToView();
  return (
    <>
      <PageMeta title="Legal" />

      <div className="LegalPage">
        <div className="LegalPage__title">
          <Text treatment="h3">Moda Operandi Legal</Text>
        </div>
        <Stack space={4}>
          <Stack className="LegalPage__section" space={4}>
            <Text treatment="bold1">Terms and Conditions</Text>
            <Text treatment="body2" family="serif">
              Terms and conditions apply to your use of our services and purchases of products from
              Moda Operandi.{' '}
              <a className="LegalPage__link" href="/terms">
                You may review these terms and conditions here.
              </a>
            </Text>
            <Text treatment="bold1">Privacy</Text>
            <Text treatment="body2" family="serif">
              <span className="LegalPage__italic">Privacy Policy</span>. Moda Operandi is committed
              to your privacy. Our{' '}
              <a className="LegalPage__link" href="/privacy">
                Privacy Policy
              </a>{' '}
              explains how we collect, use, and disclose your information.
            </Text>
            <Text treatment="body2" family="serif">
              <span className="LegalPage__italic">Event Photography Privacy Notice</span>. You can
              also review our{' '}
              <a className="LegalPage__link" href="/privacy-eventphotography">
                Privacy Notice
              </a>{' '}
              as it relates how we collect, use, and share your information and photographs and/or
              video of you when you attend a Moda Operandi event.
            </Text>
            <Text treatment="body2" family="serif">
              <span className="LegalPage__italic">Your Rights</span>. As set forth in our Privacy
              Policy, you may have certain rights related to your personal data that we process. You
              can{' '}
              <a className="LegalPage__link" href="https://preferences.modaoperandi.com/">
                submit a request here
              </a>
              .
            </Text>
            <Text treatment="bold1">Intellectual Property</Text>
            <Text treatment="body2" family="serif">
              <span className="LegalPage__italic">Trademarks</span>. You can review a{' '}
              <a className="LegalPage__link" href="/legal-trademarks">
                non-exhaustive list of Moda Operandi trademarks
              </a>
              .
            </Text>
            <Text treatment="body2" family="serif">
              <span className="LegalPage__italic">Brand Guidelines</span>. The{' '}
              <a className="LegalPage__link" href="/legal-brandguidelines">
                Moda Operandi Brand Legal Terms
              </a>{' '}
              apply to your use of Moda Operandi’s marks, if you have permission to use them.
            </Text>
            <Text treatment="body2" family="serif">
              <span className="LegalPage__italic">Copyrights</span>. Moda Operandi’s copyrighted
              material (for example, photographs, video, and marketing materials) may not be used
              without a written license from Moda Operandi. If you have any questions concerning the
              use and/or the licensing of Moda Operandi copyrighted material, please contact us at
              ip@modaoperandi.com.
            </Text>
          </Stack>
        </Stack>
      </div>
    </>
  );
};
